import { render, staticRenderFns } from "./incomestatement-premium.vue?vue&type=template&id=6875d2c0&scoped=true"
import script from "./incomestatement-premium.vue?vue&type=script&lang=js"
export * from "./incomestatement-premium.vue?vue&type=script&lang=js"
import style0 from "./incomestatement-premium.vue?vue&type=style&index=0&id=6875d2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875d2c0",
  null
  
)

export default component.exports